import React, { ReactElement, ReactNode } from 'react';
import {
  Popover as PilotPopover,
  PopoverContent,
  PopoverTrigger,
} from '../pilot-ui/popover';

/** The Device List's controlled, labelled use of the shared Popover. */
export const Popover: React.FC<{
  open: boolean;
  onClose: () => void;
  trigger: ReactElement;
  children: ReactNode;
  align?: 'left' | 'right';
  label: string;
  panelClassName?: string;
}> = ({ open, onClose, trigger, children, align = 'left', label, panelClassName }) => (
  <PilotPopover open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
    <PopoverTrigger render={trigger} />
    <PopoverContent
      align={align === 'right' ? 'end' : 'start'}
      aria-label={label}
      className={panelClassName}
    >
      {children}
    </PopoverContent>
  </PilotPopover>
);

export default Popover;
